import React, { useState } from "react";

const FailedJobItem = ({ job, onRetry, onDelete }) => {
  const [showDetails, setShowDetails] = useState(false);

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
    <div className="card shadow-sm mb-2">
      <div className="card-body p-3">
        <div className="row align-items-center">
          <div className="col-12 col-md-3">
            <div className="font-weight-bold" style={{ fontSize: "0.95rem" }}>
              {job.name}
            </div>
            <small className="text-muted">
              <i className="fa fa-layer-group mr-1" />
              {job.queue}
            </small>
          </div>
          <div className="col-12 col-md-4">
            <div
              className="text-danger small"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
              title={job.exception?.message}
            >
              <i className="fa fa-exclamation-triangle mr-1" />
              {job.exception?.message || "Erreur inconnue"}
            </div>
          </div>
          <div className="col-12 col-md-2">
            <small className="text-muted">
              <i className="fa fa-clock mr-1" />
              {formatDate(job.failedAt)}
            </small>
          </div>
          <div
            className="col-12 col-md-3 d-flex justify-content-end"
            style={{ gap: 6 }}
          >
            <button
              className="btn btn-sm btn-outline-default"
              onClick={() => setShowDetails(!showDetails)}
              title="Voir les détails"
            >
              <i className={`fa fa-chevron-${showDetails ? "up" : "down"}`} />
            </button>
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => onRetry(job.id)}
              title="Relancer le job"
              data-priv="bo_failedjobs_retry"
            >
              <i className="fa fa-redo mr-1" />
              Relancer
            </button>
            <button
              className="btn btn-sm btn-outline-danger border-danger"
              onClick={() => onDelete(job.id)}
              title="Supprimer le job"
              data-priv="bo_failedjobs_delete"
            >
              <i className="fa fa-trash" />
            </button>
          </div>
        </div>

        {showDetails && (
          <div className="mt-3 pt-3 border-top">
            <div className="row">
              <div className="col-12 col-md-6 mb-3">
                <div className="font-weight-bold small mb-1">
                  <i className="fa fa-info-circle mr-1" />
                  Informations
                </div>
                <table className="table table-sm table-borderless mb-0 small">
                  <tbody>
                    <tr>
                      <td className="text-muted" style={{ width: 120 }}>
                        ID MongoDB
                      </td>
                      <td>
                        <code>{job.id}</code>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-muted">ID Redis</td>
                      <td>
                        <code>{job.redisId}</code>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-muted">Queue</td>
                      <td>{job.queue}</td>
                    </tr>
                    <tr>
                      <td className="text-muted">Nom</td>
                      <td>{job.name}</td>
                    </tr>
                    <tr>
                      <td className="text-muted">Date d'échec</td>
                      <td>{formatDate(job.failedAt)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-12 col-md-6 mb-3">
                <div className="font-weight-bold small mb-1">
                  <i className="fa fa-database mr-1" />
                  Payload
                </div>
                <pre
                  className="bg-light p-2 rounded small mb-0"
                  style={{
                    maxHeight: 200,
                    overflow: "auto",
                    fontSize: "0.8rem",
                  }}
                >
                  {JSON.stringify(job.payload, null, 2)}
                </pre>
              </div>
              <div className="col-12">
                <div className="font-weight-bold small mb-1 text-danger">
                  <i className="fa fa-bug mr-1" />
                  Exception
                </div>
                <div className="bg-light p-2 rounded small">
                  <div className="font-weight-bold mb-1">
                    {job.exception?.message}
                  </div>
                  {job.exception?.stack && (
                    <pre
                      className="mb-0 text-muted"
                      style={{
                        maxHeight: 200,
                        overflow: "auto",
                        fontSize: "0.75rem",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {job.exception.stack}
                    </pre>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FailedJobItem;
